import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Col from "@visa/vds/col";
import Form from "@visa/vds/form";
import FormControl from "@visa/vds/form-control";
import Radio from "@visa/vds/radio";
import RadioGroup from "@visa/vds/radio-group";
import RadioGroupLegend from "@visa/vds/radio-group-legend";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { trackPromise } from "react-promise-tracker";
import { useHistory } from "react-router-dom";
import MCSControlTextArea from "../../../../components/MCSControlTextArea";
import { adminService } from "../../../../services/admin.service";
import { AdminRoutes } from "../../../../_constants/PageRoutes";
import { UserRole } from "../../../../_constants/UserRole";
import { FormHelper } from "../../../../_helpers/FormHelper";
import OrderCancellationSection from "./OrderCancellationSection";
import { Controller } from "react-hook-form";

const UpdateOrderForm = (props) => {
  const defaultValues = {
    order: props.order,
  };
  const history = useHistory();

  const { control, handleSubmit, setError, getValues, setValue } = useForm({
    defaultValues,
  });

  const [formData, setFormData] = useState(getValues());
  const updateFormData = () => setFormData(getValues());

  const onSubmit = () => {
    let orderDto = {
      orderStatus: formData.order.orderStatus,
      id: formData.order.id,
      notes: formData.order.notes,
      cancellationReason: formData.order.cancellationReason,
    };
    trackPromise(
      adminService
        .UpdateOrder(orderDto)
        .then((res) => {
          props.alertObj.setSuccessMessage("Save success!");
          history.push(AdminRoutes.MANAGESUBSCRIPTION_ORDER);
        })
        .catch((error) => {
          props.alertObj.setErrorMessage(error);
        })
    );
  };
  return (
    <>
      {props.currentUser && props.currentUser.user && (
        <>
          <Typography tag="h2">For Admin's Use</Typography>
          <Form>
            {props.order.orderStatus == 0 &&
              props.currentUser.user.entitleId !=
                UserRole.ToolsAdmin_Entitlement && (
                <Row>
                  <Col>
                    <FormControl position="left" space="fifty">
                      <RadioGroup>
                        <RadioGroupLegend>Update Order Status</RadioGroupLegend>
                        <Radio
                          name="order.orderStatus"
                          value="1"
                          label="Completed"
                          onChange={(e) => {
                            setValue("order.orderStatus", e.target.value);
                            updateFormData();
                          }}
                        />
                        <Radio
                          name="order.orderStatus"
                          value="2"
                          label="Canceled"
                          onChange={(e) => {
                            setValue("order.orderStatus", e.target.value);
                            updateFormData();
                          }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Col>
                </Row>
              )}
            {props.currentUser.user.entitleId !=
              UserRole.ToolsAdmin_Entitlement &&
              formData.order.orderStatus == "2" &&
              props.order.orderStatus == 0 && (
                <Row>
                  <Col>
                    <FormControl position="left" space="fifty">
                      <MCSControlTextArea
                        name="order.cancellationReason"
                        control={control}
                        handleChange={updateFormData}
                        rows="3"
                        autoResize
                        label="Cancellation Reason (up to 512 characters)"
                        rules={{
                          required: true,
                          maxLength: 512,
                          validate: {
                            isEmpty: (v) =>
                              FormHelper.isStringBlank(v) ||
                              "The field cannot be blank",
                          },
                        }}
                      />
                    </FormControl>
                  </Col>
                </Row>
              )}
            {props.order.orderStatus == 2 && (
              <OrderCancellationSection order={props.order} />
            )}
            <Row>
              <Col>
                <FormControl position="left" space="fifty">
                  <MCSControlTextArea
                    name="order.notes"
                    readOnly={
                      props.currentUser.user.entitleId ==
                      UserRole.ToolsAdmin_Entitlement
                    }
                    control={control}
                    handleChange={updateFormData}
                    rows="3"
                    autoResize
                    label="Notes"
                    rules={{
                      required: false,
                      maxLength: 512,
                      validate: {
                        isEmpty: (v) =>
                          FormHelper.isStringBlank(v) ||
                          "The field cannot be blank",
                      },
                    }}
                  />
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col>
                <ButtonGroup direction="right">
                  <ButtonText
                    colorScheme="tertiary"
                    onClick={() => {
                      history.push(AdminRoutes.MANAGESUBSCRIPTION_ORDER);
                    }}
                  >
                    Back
                  </ButtonText>
                  {props.currentUser.user.entitleId !=
                    UserRole.ToolsAdmin_Entitlement && (
                    <>
                      <ButtonText
                        colorScheme="primary"
                        type="submit"
                        onClick={handleSubmit(onSubmit)}
                      >
                        Save
                      </ButtonText>                      
                    </>
                  )}
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
        </>
      )}
    </>
  );
};

export default UpdateOrderForm;
